import React from 'react';

// types
import { AuthenticatedAudience } from 'ducks/merchantDucks/audience/types';

// components
import EmptyMessage from 'components/EmptyMessage';
import DonutPieChart from './charts/DonutPieChart';
import Tile from './Tile';

interface Props {
  registrationMethod: Array<AuthenticatedAudience>;
}

const RegistrationMethod: React.FC<Props> = ({ registrationMethod }) => {
  return (
    <Tile
      title="Registration method"
      tileWidth="100%"
      tileContent={
        registrationMethod ? (
          <DonutPieChart data={registrationMethod} name="name" value="total" />
        ) : (
          <EmptyMessage variant="p">There is no available data for this time period.</EmptyMessage>
        )
      }
    />
  );
};

export default RegistrationMethod;
